import React from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  AllFabricStyleATSInfoDetailsPrintRequest,
  CustomerATSInquiryCriteriaBean,
  CustomerOnOrderATSSummaryDetailsRequest,
  CustomerSalesOnOrderSearchCriteria,
  CustomerSearchCriteria,
  FabricStyleBean,
  FabricStyleCurrentATSInfoBean,
  FabricStyleInventoryDataBean,
  FabricStyleSearchCriteria,
  FabricStyleStatisticsInquiryCriteriaBean,
  ManualInventoryCustomerAllocationSearchCriteria,
  RestCustomerListRequest,
  RestCustomerSalesOnOrderListRequest,
  RestFabricStyleListBeanRequest,
  RestFabricStyleStatisticsInquiryListRequest,
  RestManualInventoryCustomerAllocationListRequest,
  RestPageListBean,
  RestPurchaseOrderInTransitListRequest,
  RestReadRequest,
  RestSkuBatchInventoryListRequest,
  RestVendorPurchaseOnOrderListRequest,
  SKUBatchInventorySearchCriteria,
  SkuBatchInventorySummaryDetailsPrintRequest,
  VendorOnOrderPrintRequest,
  VendorPurchaseOnOrderSearchCriteria,
  VendorSummaryOnOrderATSDetailsRequest,
  PageListBean,
} from "../ds/ds.js";
import { DeleteIcon, } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  CollapseComponent,
  ColumnDefinition,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupFabricStyleModule,
  PopupInvoiceModule,
  PopupPurchaseInTransitModule,
  PopupPurchaseOrderModule,
  PopupPurchaseReceiptModule,
  PopupSalesModule,
  PopupVendorModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { PurchaseOrderInTransitService } from "../services/PurchaseOrderInTransitService.js";
import { ReportService } from "../services/ReportService.js";
import { VendorService } from "../services/VendorService.js";
import CustomTable from "../gui_components/CustomTable.js";
class AllFabricCustomerAts extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.fabricCodeRef = React.createRef();
    this.itemlistCodeRef = React.createRef();
    this.state = {
      onHandQtyDataList: [],
      onHandQtySummaryDataList: [],
      customerQtyDataList: [],
      customerSummaryDataList: [],
      vendorQtyDataList: [],
      sourceSalesOrderDataList: [],
      vendorSummaryDataList: [],
      vendorInTransitQtyDataList: [],
      vendorInTransitSummaryDataList: [],
      showHide: this.props.showHide,
      pageTitle: "All Fabric Customer ATS-Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      isShowVendorCodeModule: false,
      error_list: [],
      inquiryDataList: [],
      alertMessage: "",
      summaryData: null,
      criteria: new CustomerATSInquiryCriteriaBean(),
      inventoryDataBean: new FabricStyleInventoryDataBean(),
      fabricAtsInfoBean: new FabricStyleCurrentATSInfoBean(),
      fabricVendorAtsInfoBean: new FabricStyleCurrentATSInfoBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      item_list: [],
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowFabricStyleModule: false,
      isShowCustomerModule: false,
      isShowVendorModule: false,
      isShowPurchaseOrderModule: false,
      isShowPurchaseInTransitModule: false,
      isShowPurchaseReceiptModule: false,
      isShowInvoiceModule: false,
      moduleForPopup: [],
      isShowOnHandQtyPopup: false,
      isShowOnHandQtySummaryPopup: false,
      isShowCustomerQtyPopup: false,
      isShowCustomerSummaryPopup: false,
      isShowVendorSummaryPopup: false,
      isShowVendorQtyPopup: false,
      isShowVendorInTransitQtyPopup: false,
      isShowVendorInTransitSummaryPopup: false,
      isShowAllLastMonthQtyPopup: false,
      isShowManualAllocatePopup: false,
      isShowMonthToDateQtyData: false,
      isShowlast3MonthQtyData: false,
      isShowlast6MonthQtyData: false,
      isShowlast12MonthQtyData: false,
      isShowlast18MonthQtyData: false,
      isShowlast24MonthQtyData: false,
      isShowlast36MonthQtyData: false,
      lastSalesCriteria: new FabricStyleStatisticsInquiryCriteriaBean(),
      vendorInTransitBean: new FabricStyleCurrentATSInfoBean(),
      monthToDateQtyDataList: [],
      last3MonthQtyDataList: [],
      last6MonthQtyDataList: [],
      last12MonthQtyDataList: [],
      last18MonthQtyDataList: [],
      last24MonthQtyDataList: [],
      last36MonthQtyDataList: [],
      manualAllocateList: [],
      simplePopupContent: [],
      manualAllocateCriteria:
        new ManualInventoryCustomerAllocationSearchCriteria(),
      colorLookupHandler: null,
      isShowColorLookup: false,
      fabricList: new Array(),
      locationList1: new Array(),
      locationList: null,
      fabricDatas: [],
      locationDatas: [],
      locations: [],
      locationData: null,
      isCollapsible_open: true,
      colorList: [],
      businessDivisions: [],
      fabricStyleData: new FabricStyleBean(),
      showAutoCompleteMultiFabricList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      showAutoCompleteList: false,
      showAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
      isDisableFields: false,
      is3PL: false,
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  onCustomer_CodeChange = (e) => {
    let logisticCustomerCode = e.target.value.toUpperCase();
    this.state.isShowAutoCompleteCustomerList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    if (isEmpty(logisticCustomerCode)) {
      this.state.isShowAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
      let temp_criteria = this.state.criteria;
      temp_criteria.logisticCustomerCode = "";
      temp_criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: temp_criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "logisticCustomerCode" &&
      showAutoCompleteList === true &&
      logisticCustomerCode !== ""
    ) {
      this.readCustomer_BySearchString(e.target.value);
    }
    criteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ criteria: criteria });
  };
  customer_CodeEnterKeyEventHandler = (e) => {
    let logisticCustomerCode = e.target.value;
    this.read_Customer(logisticCustomerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };

  readCustomer_BySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;

    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomer_CodeResponse,
      this.errorCallBack
    );
  }
  readByCustomer_CodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };

  readCustomer_Response = (response) => {
    const customerData = response.data.customer;
    if (customerData != null) {
      let criteria = this.state.criteria;
      criteria.logisticCustomerCode = customerData.code;
      criteria.customerName = customerData.description;
      this.setState({ criteria: criteria });
    }
  };

  read_Customer = (logisticCustomerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = logisticCustomerCode;
    readrestInput.isLoadChildren = true;

    CustomerService.readCustomerWithChildren(
      readrestInput,
      this.readCustomer_Response,
      this.errorCallBack
    );
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerCode = customerData.code;
        criteria.customerName = customerData.description;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack
    );
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  readMultiFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByMultiFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByMultiFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      multiFabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  multifabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteMultiFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteMultiFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.setState({
        showAutoCompleteMultiFabricList: false,
      });
      let showAutoCompleteList = this.state.showAutoCompleteMultiFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStylesCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteMultiFabricList: showAutoCompleteList,
        criteria: criteria,
        multiFabricPageListForAutoCompleteList: suggestion,
        fabricStyleData: null,
      });
    } else if (
      e.target.name == "fabricStylesCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readMultiFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readFabricStyleResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      criteria.fabricStylesCode = fabricStyle.code;
      this.setState({ fabricStyleData: fabricStyle });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readFabricStyle = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readFabricStyleResponse,
      this.errorCallBack
    );
  };
  multiFabricEnterKeyEventHandler = (e) => {
    this.readFabricStyle(e.target.value);
    this.setState({ multiFabricPageListForAutoCompleteList: new Array() });
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
  };
  displayAutoCompleteMultiFabricList = (showAutoCompleteMultiFabricList) => {
    this.setState({
      showAutoCompleteMultiFabricList: showAutoCompleteMultiFabricList,
    });
  };
  addFabric = () => {
    let criteria = this.state.criteria;
    criteria.fabricStylesCode = "";
    criteria.companyCode = this.companyCode;
    let fabricStyleData = this.state.fabricStyleData;
    let fabricDatas = this.state.fabricDatas;
    if (fabricStyleData != null) {
      if (!isEmptyArray(fabricDatas) && !isEmptyString(fabricStyleData.code)) {
        let exists = fabricDatas.find((p) => p.code === fabricStyleData.code);
        if (!exists) {
          fabricDatas.push(fabricStyleData);
          criteria.includedFabricCodes.push(fabricStyleData.code);
          this.setState({
            criteria: criteria,
            fabricDatas: fabricDatas,
            fabricStyleData: new FabricStyleBean(),
          });
        }
      } else {
        if (!isEmptyString(fabricStyleData.code)) {
          fabricDatas.push(fabricStyleData);
          criteria.includedFabricCodes.push(fabricStyleData.code);
          this.setState({
            criteria: criteria,
            fabricDatas: fabricDatas,
            fabricStyleData: new FabricStyleBean(),
          });
        }
      }
    }
  };
  deleteFabric = (line) => {
    let criteria = this.state.criteria;
    let lineData = criteria.includedFabricCodes;
    let fabricDatas = this.state.fabricDatas;
    fabricDatas.map((list, index) => {
      if (list.code === line.code) {
        lineData.splice(index, 1);
        fabricDatas.splice(index, 1);
      }
    });
    this.setState({
      criteria: criteria,
      fabricStyleData: new FabricStyleBean(),
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  handleResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadCustomerAtsInquiryList(criteria);
  };
  loadCustomerAtsInquiryList = (criteria) => {
    if (
      !isEmptyString(criteria.customerCode) ||
      !isEmptyString(criteria.logisticCustomerCode)
    ) {
    if (SecurityAccessManager.AllFabricCustomerATSInquiry_IsAccessible()) {
      ReportService.inquireAllCustomerFabricStyleATSInfo(
        criteria,
        this.loadCustomerAtsPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
    } else {
      let errMsg = "CustomerCode is Required...!";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  loadCustomerAtsPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.inquiryResult) {
      let resultList = new Array();
      if (!isEmptyArray(response.data.inquiryResult.atsInfos)) {
        resultList = response.data.inquiryResult.atsInfos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        sShowClearCriteriaButton: false,
        isShowClearCriteriaButton: false,
        isShowProgressBarPopup: false,
        inquiryDataList: resultList,
        isCollapsible_open: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showHideSecondHeader = () => {
    let tempIsCollapsible_open = !this.state.isCollapsible_open;
    this.setState({ isCollapsible_open: tempIsCollapsible_open });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new CustomerATSInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.fabricStylesCode = "";
    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
      fabricDatas: [],
      locationDatas: [],
      fabricStyleData: new FabricStyleBean(),
      locationData: null,
      colorList: [],
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
      isCollapsible_open: true,
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new CustomerATSInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.fabricStylesCode = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowColorLookup: false,
      fabricDatas: [],
      fabricStyleData: null,
      isCollapsible_open: true,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleData: new FabricStyleBean(),
      locationData: null,
      colorList: [],
      isDisableFields: false,
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new AllFabricStyleATSInfoDetailsPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.AllFabricCustomerATSInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateAllFabricStyleCustomerATSInfoDetailsPrintReport(
          listRequest,
          this.generateFabricATSPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.AllFabricCustomerATSInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateAllFabricStyleCustomerATSInfoDetailsPrintReport(
          listRequest,
          this.generateFabricATSPageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateFabricATSPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
   generateFabricATSPageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
       let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  onHandQuantityClick = (e, val, rowData) => {
    if (e.detail === 1) {
      const criteria = this.state.criteria;
      const inventoryDataBean = this.state.inventoryDataBean;
      inventoryDataBean.companyCode = this.companyCode;
      inventoryDataBean.fabricStyleCode = rowData.fabricStyleCode;
      inventoryDataBean.fabricStyleName = rowData.fabricStyleName;
      inventoryDataBean.fabricStyleColorCode = rowData.fabricStyleColorCode;
      inventoryDataBean.totalOnHandQuantity = rowData.onHandQuantity;
      inventoryDataBean.uomCode = rowData.uomCode;
      this.setState({ inventoryDataBean: inventoryDataBean });
      const qtyCriteria = new SKUBatchInventorySearchCriteria();
      qtyCriteria.companyCode = this.companyCode;
      qtyCriteria.fabricStyleCode = rowData.fabricStyleCode;
      qtyCriteria.colorCode = rowData.fabricStyleColorCode;
      qtyCriteria.isExcludeNonWarehouseInventory = true;
      qtyCriteria.fetchQuantityAvailableLinesOnly = true;
      qtyCriteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      qtyCriteria.reserveCustomerCode = criteria.customerCode;
      qtyCriteria.reserveCustomerName = criteria.customerName;
      // let exludeReserveInventory =
      //   ConfigManager.excludeReserveInventoryInATSFlag();
      // qtyCriteria.excludeReserveWarehouseInventory = exludeReserveInventory;
      const pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      const listRequest = new RestSkuBatchInventoryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = qtyCriteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "fetching OnHand details...",
      });
      if (rowData.onHandQuantity > 0) {
        this.loadOnHandQtyListPage(listRequest);
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No OnHand Qty";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadOnHandQtyListPage = (listRequest) => {
    InventoryService.getSkuBatchInventoryPageList(
      listRequest,
      this.loadOnHandQtyPageResponse,
      this.errorCallBack
    );
  };
  loadOnHandQtyPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.skuBatchInventoryPageList != null
    ) {
      const onHandQtyList =
        response.data.skuBatchInventoryPageList.skuBatchInventories;
      if (onHandQtyList != null) {
        this.setState({
          onHandQtyDataList: onHandQtyList,
          isShowOnHandQtyPopup: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateOnHandQtyPdf = (e) => {
    if (e.detail === 1) this.generateOnHandQtyReport(1);
  };
  generateOnHandQtyExcel = (e) => {
    if (e.detail === 1) this.generateOnHandQtyReport(2);
  };
  generateOnHandQtyReport = (reportType) => {
    let inventoryDataBean = this.state.inventoryDataBean;
    let criteria = new SKUBatchInventorySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = inventoryDataBean.fabricStyleCode;
    criteria.colorCode = inventoryDataBean.fabricStyleColorCode;
    criteria.excludedLocationCodes = this.state.criteria.excludedLocationCodes;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new RestSkuBatchInventoryListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
      if (reportBean.reportType == 1) {
    ReportService.downloadPopUpItemOnOrderPrintReport(
      listRequest,
      this.generateOnHandQtyResponse,
      this.errorCallBack
    );
   }else if(reportBean.reportType == 2){
 ReportService.downloadPopUpItemOnOrderPrintReport(
      listRequest,
      this.generateOnHandQtyResponseForExcel,
      this.errorCallBack
    );
   }
  };
  generateOnHandQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateOnHandQtyResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
               window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onHandQtySummaryOnClick = (e) => {
    if (e.detail === 1) {
      let inventoryDataBean = this.state.inventoryDataBean;
      let criteria = new SKUBatchInventorySearchCriteria();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = inventoryDataBean.fabricStyleCode;
      criteria.colorCode = inventoryDataBean.fabricStyleColorCode;
      criteria.excludeNonWarehouseInventory = true;
      criteria.fetchQuantityAvailableLinesOnly = true;
      let exludeReserveInventory =
        ConfigManager.excludeReserveInventoryInATSFlag();
      criteria.excludeReserveWarehouseInventory = exludeReserveInventory;
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestSkuBatchInventoryListRequest();
      listRequest.searchCriteria = criteria;
      listRequest.pageInput = pageInput;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Fetching SkuBatch Inventories...",
      });
      InventoryService.getSKUBatchInventoriesSummary(
        criteria,
        this.loadOnHandQtySummaryResponse,
        this.errorCallBack
      );
    }
  };
  loadOnHandQtySummaryResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.skuBatchSummaryResult != null &&
      response.data.skuBatchSummaryResult.inventorySummaryBean != null
    ) {
      const onHandQtySummaryDataList =
        response.data.skuBatchSummaryResult.inventorySummaryBean;
      this.setState({
        onHandQtySummaryDataList: onHandQtySummaryDataList,
        isShowOnHandQtySummaryPopup: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateOnHandQtySummaryPdf = (e) => {
    if (e.detail === 1) this.generateOnHandQtySummaryReport(1);
  };
  generateOnHandQtySummaryExcel = (e) => {
    if (e.detail === 1) this.generateOnHandQtySummaryReport(2);
  };
  generateOnHandQtySummaryReport = (reportType) => {
    let inventoryDataBean = this.state.inventoryDataBean;
    let criteria = new SKUBatchInventorySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = inventoryDataBean.fabricStyleCode;
    criteria.colorCode = inventoryDataBean.fabricStyleColorCode;
    criteria.excludeNonWarehouseInventory = true;
    criteria.fetchQuantityAvailableLinesOnly = true;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new SkuBatchInventorySummaryDetailsPrintRequest();
    listRequest.criteria = criteria;
    listRequest.input = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
    ReportService.getSkuBatchInventorySummaryDetailsPrintReport(
      listRequest,
      this.generateOnHandQtySummaryResponse,
      this.errorCallBack
    );
  }else if (reportBean.reportType == 2) {
    ReportService.getSkuBatchInventorySummaryDetailsPrintReport(
      listRequest,
      this.generateOnHandQtySummaryResponseForExcel,
      this.errorCallBack
    );
  }
  };
  generateOnHandQtySummaryResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateOnHandQtySummaryResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
               window.open(downloadAddress, "_blank");
        
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  customerOnOrderQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let fabricAtsInfoBean = this.state.fabricAtsInfoBean;
      fabricAtsInfoBean.companyCode = this.companyCode;
      fabricAtsInfoBean.fabricStyleCode = rowData.fabricStyleCode;
      fabricAtsInfoBean.fabricStyleName = rowData.fabricStyleName;
      fabricAtsInfoBean.fabricStyleColorCode = rowData.fabricStyleColorCode;
      fabricAtsInfoBean.totalCustOnOrderQuantity =
        rowData.customerOnOrderQuantity;
      this.setState({ fabricAtsInfoBean: fabricAtsInfoBean });
      let custQtyCriteria = new CustomerSalesOnOrderSearchCriteria();
      custQtyCriteria.companyCode = this.companyCode;
      custQtyCriteria.fabricStyleCode = rowData.fabricStyleCode;
      custQtyCriteria.colorCode = rowData.fabricStyleColorCode;
      custQtyCriteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestCustomerSalesOnOrderListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = custQtyCriteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Customer OnOrder detais...",
      });
      if (rowData.customerOnOrderQuantity != 0) {
        this.loadCustomerOnOrderQtyListPage(listRequest);
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No data found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadCustomerOnOrderQtyListPage = (listRequest) => {
    CustomerService.getCustomerSalesOnOrderDetailsForFabricStyleStatistics(
      listRequest,
      this.loadCustomerOnOrderQtyPageResponse,
      this.errorCallBack
    );
  };
  loadCustomerOnOrderQtyPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.orderDetailsResult != null &&
      response.data.orderDetailsResult.onOrderInfoDetails != null
    ) {
      const customerQtyDataList =
        response.data.orderDetailsResult.onOrderInfoDetails;
      this.setState({
        customerQtyDataList: customerQtyDataList,
        isShowCustomerQtyPopup: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateCustomerOnOrderPdf = (e) => {
    if (e.detail === 1) this.generateCustomerOnOrderReport(1);
  };
  generateCustomerOnOrderExcel = (e) => {
    if (e.detail === 1) this.generateCustomerOnOrderReport(2);
  };
  generateCustomerOnOrderReport = (reportType) => {
    let fabricAtsInfoBean = this.state.fabricAtsInfoBean;
    let criteria = new CustomerSalesOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricAtsInfoBean.fabricStyleCode;
    criteria.colorCode = fabricAtsInfoBean.fabricStyleColorCode;
    criteria.excludedLocationCodes = this.state.criteria.excludedLocationCodes;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new RestCustomerSalesOnOrderListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
     if (reportBean.reportType == 1) {
    ReportService.downloadPopUpCustomerOnOrderPrintReport(
      listRequest,
      this.generateCustomerOnOrderResponse,
      this.errorCallBack
    );
  }
    else if (reportBean.reportType == 2) {
       ReportService.downloadPopUpCustomerOnOrderPrintReport(
      listRequest,
      this.generateCustomerOnOrderResponseForExcel,
      this.errorCallBack
    );
    }

  };
  generateCustomerOnOrderResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
 generateCustomerOnOrderResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
               window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  summaryOnClick = (e) => {
    if (e.detail === 1) {
      let fabricAtsInfoBean = this.state.fabricAtsInfoBean;
      let criteria = new CustomerATSInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = fabricAtsInfoBean.fabricStyleCode;
      criteria.fabricStyleColorCode = fabricAtsInfoBean.fabricStyleColorCode;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Summary...",
      });
      this.loadCustomerOrderSummaryPage(criteria);
    }
  };
  loadCustomerOrderSummaryPage = (criteria) => {
    ReportService.geCustomerOnOrderATSSummary(
      criteria,
      this.loadCustomerOrderSummaryPageResponse,
      this.errorCallBack
    );
  };
  loadCustomerOrderSummaryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.inquiryResult != null &&
      response.data.inquiryResult.info != null
    ) {
      const customerSummaryDataList = response.data.inquiryResult.info;
      this.setState({
        customerSummaryDataList: customerSummaryDataList,
        isShowCustomerSummaryPopup: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    } else {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      let errMsg = "No Data Found";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  generateCustomerSummaryPdf = (e) => {
    if (e.detail === 1) this.generateCustomerSummaryReport(1);
  };
  generateCustomerSummaryExcel = (e) => {
    if (e.detail === 1) this.generateCustomerSummaryReport(2);
  };
  generateCustomerSummaryReport = (reportType) => {
    let fabricAtsInfoBean = this.state.fabricAtsInfoBean;
    let criteria = new CustomerATSInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricAtsInfoBean.fabricStyleCode;
    criteria.fabricStyleColorCode = fabricAtsInfoBean.fabricStyleColorCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new CustomerOnOrderATSSummaryDetailsRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generate Report...",
    });
      if (reportBean.reportType == 1) {
    ReportService.getCustomerOnOrderATSSummaryDetailsReport(
      listRequest,
      this.generateCustomerSummaryResponse,
      this.errorCallBack
    );
  }else if(reportBean.reportType == 2){
     ReportService.getCustomerOnOrderATSSummaryDetailsReport(
      listRequest,
      this.generateCustomerSummaryResponseForExcel,
      this.errorCallBack
    );
  }
  };
  generateCustomerSummaryResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
   generateCustomerSummaryResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      let reportFilePath = response.data.reportResult.reportFileID;
     let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
             window.open(downloadAddress, "_blank");
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  vendorOnOrderQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let fabricVendorAtsInfoBean = new FabricStyleCurrentATSInfoBean();
      fabricVendorAtsInfoBean.companyCode = this.companyCode;
      fabricVendorAtsInfoBean.fabricStyleCode = rowData.fabricStyleCode;
      fabricVendorAtsInfoBean.fabricStyleName = rowData.fabricStyleName;
      fabricVendorAtsInfoBean.fabricStyleColorCode =
        rowData.fabricStyleColorCode;
      fabricVendorAtsInfoBean.vendorOnOrderQuantity =
        rowData.vendorOnOrderQuantity;
      fabricVendorAtsInfoBean.inTransitQuantity = rowData.inTransitQuantity;
      this.setState({ fabricVendorAtsInfoBean: fabricVendorAtsInfoBean });
      let vendorQtyCriteria = new VendorPurchaseOnOrderSearchCriteria();
      vendorQtyCriteria.companyCode = this.companyCode;
      vendorQtyCriteria.fabricStyleCode = rowData.fabricStyleCode;
      vendorQtyCriteria.colorCode = rowData.fabricStyleColorCode;
      vendorQtyCriteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestVendorPurchaseOnOrderListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = vendorQtyCriteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading vendorOnOrder...",
      });
      if (rowData.vendorOnOrderQuantity != 0) {
        this.loadVendorOnOrderQtyListPage(listRequest);
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No data found";
        let errList = [];
        errList.push(errMsg);
        this.setState({ error_list: errList });
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadVendorOnOrderQtyListPage = (listRequest) => {
    VendorService.getVendorPurchaseOnOrderDetailsForFabricStyleStatistics(
      listRequest,
      this.loadPOFabricStatisticsResponse,
      this.errorCallBack
    );
  };
  loadPOFabricStatisticsResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.orderDetailsResult != null) {
      let vendorQtyDataList = new Array();
      let sourceSalesOrderDataList = new Array();
      if (response.data.orderDetailsResult.onOrderInfoDetails != null) {
        vendorQtyDataList = response.data.orderDetailsResult.onOrderInfoDetails;
      }
      if (response.data.orderDetailsResult.sourceOrderDetailLines != null) {
        sourceSalesOrderDataList =
          response.data.orderDetailsResult.sourceOrderDetailLines;
      }
      this.setState({
        vendorQtyDataList: vendorQtyDataList,
        sourceSalesOrderDataList: sourceSalesOrderDataList,
        isShowVendorQtyPopup: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateVendorOnOrderPdf = (e) => {
    if (e.detail === 1) this.generateVendorOnOrderReport(1);
  };
  generateVendorOnOrderExcel = (e) => {
    if (e.detail === 1) this.generateVendorOnOrderReport(2);
  };
  generateVendorOnOrderReport = (reportType) => {
    let fabricVendorAtsInfoBean = this.state.fabricVendorAtsInfoBean;
    let criteria = new VendorPurchaseOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricVendorAtsInfoBean.fabricStyleCode;
    criteria.colorCode = fabricVendorAtsInfoBean.fabricStyleColorCode;
    criteria.excludedLocationCodes = this.state.criteria.excludedLocationCodes;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new VendorOnOrderPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
     if (reportBean.reportType == 1) {
    ReportService.generateVendorOnOrderPrintReport(
      listRequest,
      this.generateVendorOnOrderResponse,
      this.errorCallBack
    );
  }
  else if(reportBean.reportType == 2) {
    ReportService.generateVendorOnOrderPrintReport(
      listRequest,
      this.generateVendorOnOrderResponseForExcel,
      this.errorCallBack
    );
  }
  };
  generateVendorOnOrderResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
   generateVendorOnOrderResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  vendorSummaryOnClick = (e) => {
    if (e.detail === 1) {
      let fabricVendorAtsInfoBean = this.state.fabricVendorAtsInfoBean;
      let criteria = new VendorPurchaseOnOrderSearchCriteria();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = fabricVendorAtsInfoBean.fabricStyleCode;
      criteria.colorCode = fabricVendorAtsInfoBean.fabricStyleColorCode;
      let pageInput = new PageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestVendorPurchaseOnOrderListRequest();
      listRequest.searchCriteria = criteria;
      listRequest.pageInput = pageInput;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Vendor Summary...",
      });
      this.loadVendorOrderSummaryPage(listRequest);
    }
  };
  loadVendorOrderSummaryPage = (criteria) => {
    ReportService.getVendorSummaryOnOrderATSQuantities(
      criteria,
      this.loadVendorOrderSummaryPageResponse,
      this.errorCallBack
    );
  };
  loadVendorOrderSummaryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.orderDetailsResult != null) {
      if (response.data.orderDetailsResult.onOrderInfoDetails != null) {
        const vendorSummaryDataList =
          response.data.orderDetailsResult.onOrderInfoDetails;
        this.setState({
          vendorSummaryDataList: vendorSummaryDataList,
          isShowVendorSummaryPopup: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No Data Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  generateVendorSummaryPdf = (e) => {
    if (e.detail === 1) this.generateVendorSummaryReport(1);
  };
  generateVendorSummaryExcel = (e) => {
    if (e.detail === 1) this.generateVendorSummaryReport(2);
  };
  generateVendorSummaryReport = (reportType) => {
    let fabricVendorAtsInfoBean = this.state.fabricVendorAtsInfoBean;
    let criteria = new VendorPurchaseOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricVendorAtsInfoBean.fabricStyleCode;
    criteria.colorCode = fabricVendorAtsInfoBean.fabricStyleColorCode;
    criteria.excludedLocationCodes = this.state.criteria.excludedLocationCodes;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new VendorSummaryOnOrderATSDetailsRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generate Report...",
    });
     if (reportBean.reportType == 1) {
    ReportService.getVendorSummaryOnOrderATSDetailsReport(
      listRequest,
      this.generateVendorSummaryResponse,
      this.errorCallBack
    );
  }
  else if (reportBean.reportType == 2) {
    ReportService.getVendorSummaryOnOrderATSDetailsReport(
      listRequest,
      this.generateVendorSummaryResponseForExcel,
      this.errorCallBack
    );
  }
  };
  generateVendorSummaryResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
    generateVendorSummaryResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
       let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
               window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowOnHandQtyPopup: isShowPopup,
      isShowCustomerQtyPopup: isShowPopup,
      isShowVendorQtyPopup: isShowPopup,
      isShowVendorInTransitQtyPopup: isShowPopup,
      isShowAllLastMonthQtyPopup: isShowPopup,
      isShowMonthToDateQtyData: false,
      isShowlast3MonthQtyData: false,
      isShowlast6MonthQtyData: false,
      isShowlast12MonthQtyData: false,
      isShowlast18MonthQtyData: false,
      isShowlast24MonthQtyData: false,
      isShowlast36MonthQtyData: false,
      isShowManualAllocatePopup: false,
    });
  };
  closeAlertSummaryModalCallBack = (isShowPopup) => {
    this.setState({
      isShowCustomerSummaryPopup: isShowPopup,
      isShowVendorSummaryPopup: isShowPopup,
      isShowOnHandQtySummaryPopup: isShowPopup,
      isShowVendorInTransitSummaryPopup: isShowPopup,
    });
  };
  vendorInTransitQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let vendorInTransitBean = new FabricStyleCurrentATSInfoBean();
      vendorInTransitBean.fabricStyleCode = rowData.fabricStyleCode;
      vendorInTransitBean.fabricStyleName = rowData.fabricStyleName;
      vendorInTransitBean.fabricStyleColorCode = rowData.fabricStyleColorCode;
      vendorInTransitBean.vendorOnOrderQuantity = rowData.vendorOnOrderQuantity;
      vendorInTransitBean.inTransitQuantity = rowData.inTransitQuantity;
      this.setState({ vendorInTransitBean: vendorInTransitBean });
      let vendorQtyCriteria = new VendorPurchaseOnOrderSearchCriteria();
      vendorQtyCriteria.companyCode = this.companyCode;
      vendorQtyCriteria.fabricStyleCode = rowData.fabricStyleCode;
      vendorQtyCriteria.colorCode = rowData.fabricStyleColorCode;
      vendorQtyCriteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestVendorPurchaseOnOrderListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = vendorQtyCriteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading vendor InTransit Qty...",
      });
      if (rowData.inTransitQuantity != 0) {
        this.loadVendorInTransitQtyListPage(listRequest);
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No data found";
        let errList = [];
        errList.push(errMsg);
        this.setState({ error_list: errList });
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadVendorInTransitQtyListPage = (listRequest) => {
    PurchaseOrderInTransitService.getVendorPurchaseOrderInTransitDetailsForFabricStyleStatistics(
      listRequest,
      this.loadVendorInTransitResponse,
      this.errorCallBack
    );
  };
  loadVendorInTransitResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.inTransitDetailsResult != null) {
      if (response.data.inTransitDetailsResult.inTransitInfoDetails != null) {
        let vendorInTransitQtyDataList =
          response.data.inTransitDetailsResult.inTransitInfoDetails;
        this.setState({
          vendorInTransitQtyDataList: vendorInTransitQtyDataList,
          isShowVendorInTransitQtyPopup: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateVendorInTransitPdf = (e) => {
    if (e.detail === 1) this.generateVendorInTransitReport(1);
  };
  generateVendorInTransitExcel = (e) => {
    if (e.detail === 1) this.generateVendorInTransitReport(2);
  };
  generateVendorInTransitReport = (reportType) => {
    let vendorInTransitBean = this.state.vendorInTransitBean;
    let criteria = new VendorPurchaseOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = vendorInTransitBean.fabricStyleCode;
    criteria.colorCode = vendorInTransitBean.fabricStyleColorCode;
    criteria.excludedLocationCodes = this.state.criteria.excludedLocationCodes;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new RestVendorPurchaseOnOrderListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
     if (reportBean.reportType == 1) {
    ReportService.generateVendorInTransitPrintReport(
      listRequest,
      this.generateInTransitResponse,
      this.errorCallBack
    );
  }
   else if (reportBean.reportType == 2) {
     ReportService.generateVendorInTransitPrintReport(
      listRequest,
      this.generateInTransitResponseForExcel,
      this.errorCallBack
    );
   }
  };
  generateInTransitResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
   generateInTransitResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
               window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  vendorInTransitSummaryOnClick = (e) => {
    if (e.detail === 1) {
      let vendorInTransitBean = this.state.vendorInTransitBean;
      let intransitQtyCriteria = new VendorPurchaseOnOrderSearchCriteria();
      intransitQtyCriteria.companyCode = this.companyCode;
      intransitQtyCriteria.fabricStyleCode =
        vendorInTransitBean.fabricStyleCode;
      intransitQtyCriteria.colorCode = vendorInTransitBean.fabricStyleColorCode;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new RestPurchaseOrderInTransitListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = intransitQtyCriteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading VendorIntransit Summary...",
      });
      this.loadVendorInTransitSummaryPage(listRequest);
    }
  };
  loadVendorInTransitSummaryPage = (listRequest) => {
    PurchaseOrderInTransitService.getInTransitSummaryDetails(
      listRequest,
      this.loadVendorInTransitSummaryResponse,
      this.errorCallBack
    );
  };
  loadVendorInTransitSummaryResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null) {
      if (response.data.inTransitSummaryDetailsResult != null) {
        if (
          response.data.inTransitSummaryDetailsResult.inTransitSummaryDetails !=
          null
        ) {
          let vendorInTransitSummaryDataList =
            response.data.inTransitSummaryDetailsResult.inTransitSummaryDetails;
          this.setState({
            vendorInTransitSummaryDataList: vendorInTransitSummaryDataList,
            isShowVendorInTransitSummaryPopup: true,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        } else {
          this.setState({
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
          let errMsg = "No Data Found";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  generateVendorInTransitSummaryPdf = (e) => {
    if (e.detail === 1) this.generateVendorInTransitSummaryReport(1);
  };
  generateVendorInTransitSummaryExcel = (e) => {
    if (e.detail === 1) this.generateVendorInTransitSummaryReport(2);
  };
  generateVendorInTransitSummaryReport = (reportType) => {
    let vendorInTransitSummaryBean = this.state.vendorInTransitBean;
    let criteria = new VendorPurchaseOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = vendorInTransitSummaryBean.fabricStyleCode;
    criteria.colorCode = vendorInTransitSummaryBean.fabricStyleColorCode;
    criteria.excludedLocationCodes = this.state.criteria.excludedLocationCodes;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new RestVendorPurchaseOnOrderListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
     if (reportBean.reportType == 1) {
    ReportService.getInTransitSummaryDetailsPrintReport(
      listRequest,
      this.generateInTransitSummaryResponse,
      this.errorCallBack
    );
  }else if (reportBean.reportType == 2) {
    ReportService.getInTransitSummaryDetailsPrintReport(
      listRequest,
      this.generateInTransitSummaryResponseForExcel,
      this.errorCallBack
    );
  }
  };
  generateInTransitSummaryResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
   generateInTransitSummaryResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
         let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
                window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  monthToDateQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.fabricStyleName = rowData.fabricStyleName;
      criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
      criteria.historyDate = rowData.lastSalesDate;
      criteria.onOrderQuantity = rowData.monthToDateQuantity;
      criteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      this.setState({ lastSalesCriteria: criteria });
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestFabricStyleStatisticsInquiryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = criteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Month to Date salesInvoice...",
      });
      if (val > 0) {
      ReportService.getInvoiceListForMonthsToDateSalesInvoiceForFabricStyleStatistics(
        listRequest,
        this.loadMonthToDateQtyResponse,
        this.errorCallBack
      );
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No Data Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadMonthToDateQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      if (response.data.result.invoice != null) {
        let monthToDateQtyDataList = response.data.result.invoices;
        this.setState({
          monthToDateQtyDataList: monthToDateQtyDataList,
          isShowAllLastMonthQtyPopup: true,
          isShowMonthToDateQtyData: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  last3MonthQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.fabricStyleName = rowData.fabricStyleName;
      criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
      criteria.historyDate = rowData.lastSalesDate;
      criteria.onOrderQuantity = rowData.last3MonthsSalesQuantity;
      criteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      this.setState({ lastSalesCriteria: criteria });
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestFabricStyleStatisticsInquiryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = criteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Last 3Months Data...",
      });
      if (val > 0) {
        ReportService.getInvoiceListForLast3MonthsSalesInvoiceForFabricStyleStatistics(
          listRequest,
          this.loadLast3MonthQtyResponse,
          this.errorCallBack
        );
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No Data Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadLast3MonthQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let last3MonthQtyDataList = response.data.result.invoices;
      if (last3MonthQtyDataList != null) {
        this.setState({
          last3MonthQtyDataList: last3MonthQtyDataList,
          isShowAllLastMonthQtyPopup: true,
          isShowlast3MonthQtyData: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateMonthToDateQtyPdf = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(1, 1);
  };
  generateMonthToDateQtyExcel = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(2, 1);
  };
  generateLast3MonthPdf = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(1, 3);
  };
  generateLast3MonthExcel = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(2, 3);
  };
  generateLast6MonthPdf = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(1, 6);
  };
  generateLast6MonthExcel = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(2, 6);
  };
  generateLast12MonthPdf = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(1, 12);
  };
  generateLast12MonthExcel = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(2, 12);
  };
  generateLast18MonthPdf = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(1, 18);
  };
  generateLast18MonthExcel = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(2, 18);
  };
  generateLast24MonthPdf = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(1, 24);
  };
  generateLast24MonthExcel = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(2, 24);
  };
  generateLast36MonthPdf = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(1, 36);
  };
  generateLast36MonthExcel = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(2, 36);
  };
  generateLastSalesDetailsReport = (reportType, numberOfMonths) => {
  
   
    
    let lastSalesCriteria = this.state.lastSalesCriteria;
    let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = lastSalesCriteria.fabricStyleCode;
    criteria.fabricStyleColorCode = lastSalesCriteria.fabricStyleColorCode;
    criteria.excludedLocationCodes = this.state.criteria.excludedLocationCodes;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new RestFabricStyleStatisticsInquiryListRequest();
    listRequest.searchCriteria = lastSalesCriteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    listRequest.numberOfMonthsFrom = numberOfMonths;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generate Report...",
    });
    if  (reportBean.reportType == 1) {
    ReportService.generatePopUpLastSalesDetailsATSPrintReport(
      listRequest,
      this.generateLastSalesDetailResponse,
      this.errorCallBack
    );
  } else if(reportBean.reportType == 2) {
    ReportService.generatePopUpLastSalesDetailsATSPrintReport(
      listRequest,
      this.generateLastSalesDetailResponseForExcel,
      this.errorCallBack
    );
  }

  
  };
  generateLastSalesDetailResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateLastSalesDetailResponseForExcel = (response) => {
    
    
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        
        
         let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        
         window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  last6MonthQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.fabricStyleName = rowData.fabricStyleName;
      criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
      criteria.historyDate = rowData.lastSalesDate;
      criteria.onOrderQuantity = rowData.last6MonthsSalesQuantity;
      criteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      this.setState({ lastSalesCriteria: criteria });
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestFabricStyleStatisticsInquiryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = criteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Last 6 months Data...",
      });
      if (val > 0) {
        ReportService.getInvoiceListForLast6MonthsSalesInvoiceForFabricStyleStatistics(
          listRequest,
          this.loadLast6MonthQtyResponse,
          this.errorCallBack
        );
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No Data Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadLast6MonthQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      if (response.data.result.invoices != null) {
        let last6MonthQtyDataList = response.data.result.invoices;
        this.setState({
          last6MonthQtyDataList: last6MonthQtyDataList,
          isShowAllLastMonthQtyPopup: true,
          isShowlast6MonthQtyData: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  last12MonthQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.fabricStyleName = rowData.fabricStyleName;
      criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
      criteria.historyDate = rowData.lastSalesDate;
      criteria.onOrderQuantity = rowData.last12MonthsSalesQuantity;
      criteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      this.setState({ lastSalesCriteria: criteria });
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestFabricStyleStatisticsInquiryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = criteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading last 12 months Data...",
      });
      if (val > 0) {
        ReportService.getInvoiceListForLast12MonthsSalesInvoiceForFabricStyleStatistics(
          listRequest,
          this.loadLast12MonthQtyResponse,
          this.errorCallBack
        );
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No Data Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadLast12MonthQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      if (response.data.result.invoices != null) {
        let last12MonthQtyDataList = response.data.result.invoices;
        this.setState({
          last12MonthQtyDataList: last12MonthQtyDataList,
          isShowAllLastMonthQtyPopup: true,
          isShowlast12MonthQtyData: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  last18MonthQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.fabricStyleName = rowData.fabricStyleName;
      criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
      criteria.historyDate = rowData.lastSalesDate;
      criteria.onOrderQuantity = rowData.last18MonthsSalesQuantity;
      criteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      this.setState({ lastSalesCriteria: criteria });
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestFabricStyleStatisticsInquiryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = criteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Last 18 Months Data...",
      });
      if (val > 0) {
        ReportService.getInvoiceListForLast18MonthsSalesInvoiceForFabricStyleStatistics(
          listRequest,
          this.loadLast18MonthQtyResponse,
          this.errorCallBack
        );
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No Data Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadLast18MonthQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      if (response.data.result.invoices != null) {
        let last18MonthQtyDataList = response.data.result.invoices;
        this.setState({
          last18MonthQtyDataList: last18MonthQtyDataList,
          isShowAllLastMonthQtyPopup: true,
          isShowlast18MonthQtyData: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  last24MonthQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.fabricStyleName = rowData.fabricStyleName;
      criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
      criteria.historyDate = rowData.lastSalesDate;
      criteria.onOrderQuantity = rowData.last24MonthsSalesQuantity;
      criteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      this.setState({ lastSalesCriteria: criteria });
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestFabricStyleStatisticsInquiryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = criteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Last 24 Months Data...",
      });
      if (val > 0) {
        ReportService.getInvoiceListForLast24MonthsSalesInvoiceForFabricStyleStatistics(
          listRequest,
          this.loadLast24MonthQtyResponse,
          this.errorCallBack
        );
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No Data Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadLast24MonthQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      if (response.data.result.invoices != null) {
        let last24MonthQtyDataList = response.data.result.invoices;
        this.setState({
          last24MonthQtyDataList: last24MonthQtyDataList,
          isShowAllLastMonthQtyPopup: true,
          isShowlast24MonthQtyData: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  last36MonthQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.fabricStyleName = rowData.fabricStyleName;
      criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
      criteria.historyDate = rowData.lastSalesDate;
      criteria.onOrderQuantity = rowData.last36MonthsSalesQuantity;
      criteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      this.setState({ lastSalesCriteria: criteria });
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestFabricStyleStatisticsInquiryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = criteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Last 36 Months Data...",
      });
      if (val > 0) {
        ReportService.getInvoiceListForLast36MonthsSalesInvoiceForFabricStyleStatistics(
          listRequest,
          this.loadLast36MonthQtyResponse,
          this.errorCallBack
        );
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No Data Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadLast36MonthQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      if (response.data.result.invoices != null) {
        let last36MonthQtyDataList = response.data.result.invoices;
        this.setState({
          last36MonthQtyDataList: last36MonthQtyDataList,
          isShowAllLastMonthQtyPopup: true,
          isShowlast36MonthQtyData: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  manualAllocateQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let criteria = new ManualInventoryCustomerAllocationSearchCriteria();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.fabricStyleName = rowData.fabricStyleName;
      criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
      criteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      this.setState({ manualAllocateCriteria: criteria });
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestManualInventoryCustomerAllocationListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = criteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Manual Allocation List...",
      });
      if (val > 0) {
        InventoryService.getManualInventoryCustomerAllocationPageList(
          listRequest,
          this.loadManualAllocateQtyResponse,
          this.errorCallBack
        );
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No Data Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadManualAllocateQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.customerAllocationPageList != null
    ) {
      if (
        response.data.customerAllocationPageList.customerAllocations != null
      ) {
        let manualAllocateDataList =
          response.data.customerAllocationPageList.customerAllocations;
        this.setState({
          manualAllocateList: manualAllocateDataList,
          isShowManualAllocatePopup: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateManualAllocatePdf = (e) => {
    if (e.detail === 1) this.generateManualAllocateReport(1);
  };
  generateManualAllocateExcel = (e) => {
    if (e.detail === 1) this.generateManualAllocateReport(2);
  };
  generateManualAllocateReport = (reportType) => {
    let manualAllocateCriteria = this.state.manualAllocateCriteria;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new RestManualInventoryCustomerAllocationListRequest();
    listRequest.searchCriteria = manualAllocateCriteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if( reportBean.reportType = 1){
    ReportService.downloadPopUpManualCustomerAllocationPrintOutReport(
      listRequest,
      this.generateManualAllocateResponse,
      this.errorCallBack
    );
  }else if( reportBean.reportType = 2){
    ReportService.downloadPopUpManualCustomerAllocationPrintOutReport(
      listRequest,
      this.generateManualAllocateResponseForExcel,
      this.errorCallBack
    );
  }
  };
  generateManualAllocateResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
   generateManualAllocateResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
          let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
                window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  /* MODULE POPUP */
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewFabricModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewVendorModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowVendorModule: true,
          moduleForPopup: (
            <PopupVendorModule
              vendorCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPoModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseOrderModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPurchaseReceiptModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseReceiptModule: true,
          moduleForPopup: (
            <PopupPurchaseReceiptModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowVendorModule: isOpen,
      isShowPurchaseOrderModule: isOpen,
      isShowPurchaseReceiptModule: isOpen,
      isShowInvoiceModule: isOpen,
      moduleForPopup: [],
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };

  riskvalueHandler = (risk) => {
    if (risk === 1) {
      return "bg-yellow"
    } else if (risk === 2) {
      return "bg-pink"
    } else if (risk === 3) {
      return "bg-red";
    } else if (risk === 0) {
      return "bg-green";
    } else {
      return "bg-green";
    }
  };
  inquiryColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item#" : "FabricStyle#",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item Name" : "FabricStyle Name",
          "fabricStyleName",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-3")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("ColorName", "fabricStyleColorName", true)
        .setStyleDetails("left", "8", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SkuNumber", "skuNumber", true, true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.onHandQuantityClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Roll", "numberOfRolls", true, true)

        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ManualAllocQty", "manualAllocatedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.manualAllocateQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustOnOrder", "customerOnOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.customerOnOrderQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VndrOnOrder", "vendorOnOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.vendorOnOrderQtyClick, null)
    )
    columns.push(
      new ColumnDefinition()
        .setDetails("Intransit", "inTransitQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.vendorInTransitQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ATS YD", "atsYardage", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Risk", "", true)
        .setGraphDetails(true, this.riskvalueHandler)
        .setStyleDetails("center", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("MTDQty", "monthToDateQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.monthToDateQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("3mnth", "last3MonthsSalesQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.last3MonthQtyClick, null)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("6mnth", "last6MonthsSalesQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.last6MonthQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("12mnth", "last12MonthsSalesQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3 ", "wt-3")
        .setClickDetails(true, false, this.last12MonthQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("18mnth", "last18MonthsSalesQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.last18MonthQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("24mnth", "last24MonthsSalesQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.last24MonthQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("36mnth", "last36MonthsSalesQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.last36MonthQtyClick, null)
    );
    return columns;

  };
  onHandQtyColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Inventory#" : "RollSKU#",
          "rollSkuNumber",
          true,
          true
        )
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Receipt#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPurchaseReceiptModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty#", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("BinLoc#", "aisleInfoText", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Cust#",
          "reserveCustomerCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Name",
          "reserveCustomerName",
          true
        )

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    return columns;
  };
  onHandQtySummaryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Cust#",
          "reserveCustomerCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Name",
          "reserveCustomerName",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("No.Of.Rolls", "totalNumberOfRolls", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalYardage", "totalYardage", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  manualAllocationQtyColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "10", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "customerName", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer PO#", "customerPurchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item#" : "FabricStyle#",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item Name" : "FabricStyle Name",
          "fabricStyleName",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthCode", true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sku", "skuNumber", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("StartDate", "startDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("StopDate", "stopDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AllocatedQty", "allocatedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  customerOnHandQtySummaryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerCode#", "customerCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalQuantity", "customerOnOrderQuantity", true ,true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };

  vendorOnhandQtySummaryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Vendor#",
          "vendorCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")

    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "VendorName",
          "vendorName",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalQuantity", "onOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  vendorIntransitOnhandQtySummaryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Customer#",
          "customerCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "CustomerName",
          "customerName",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Container#", "containerNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(" ETA Date", "etaDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalYardage", "totalYards", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  }
  mtdQtyColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Customer#",
          "customerCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "CustomerName",
          "customerName",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(" Ln#", "lineNumber", true ,true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Qty", "quantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("No.Rolls", "noOfRolls", true, true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Loc#", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ShipTo", "customerShipToName", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    return columns;

  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let criteria = this.state.criteria;
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    let isLoading = this.state.isLoading;
    let onHandQtyDataList = this.state.onHandQtyDataList;
    let customerSummaryDataList = this.state.customerSummaryDataList;
    let vendorSummaryDataList = this.state.vendorSummaryDataList;
    let inventoryDataBean = this.state.inventoryDataBean;
    let fabricAtsInfoBean = this.state.fabricAtsInfoBean;
    let fabricVendorAtsInfoBean = this.state.fabricVendorAtsInfoBean;
    let lastSalesCriteria = this.state.lastSalesCriteria;
    let vendorInTransitBean = this.state.vendorInTransitBean;
    let manualAllocateCriteria = this.state.manualAllocateCriteria;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={
            this.state.is3PL
              ? "All Item Customer ATS Inquiry"
              : "All Fabric Customer ATS Inquiry"
          }
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          onModuleExit={this.onModuleExit}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          multifabricCodeOnChange={this.multifabricCodeOnChange}
          addFabric={this.addFabric}
          deleteFabric={this.deleteFabric}
          showHideSecondHeader={this.showHideSecondHeader}
          multiFabricEnterKeyEventHandler={this.multiFabricEnterKeyEventHandler}
          displayAutoCompleteMultiFabricList={
            this.displayAutoCompleteMultiFabricList
          }
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          onCustomer_CodeChange={this.onCustomer_CodeChange}
          customer_CodeEnterKeyEventHandler={
            this.customer_CodeEnterKeyEventHandler
          }
        />
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
              enableVritualizer={true}
              label={"Inquiry Data List"}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowManualAllocatePopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Manual Allocation"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateManualAllocatePdf(e)}
              >
                PDF
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateManualAllocateExcel(e)}
              >
                Excel
              </Button>
            </div>
          }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={manualAllocateCriteria.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={manualAllocateCriteria.fabricStyleName}
                    disabled={true}
                  />
                </Col>

                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={manualAllocateCriteria.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
              </Row>

              <div className="mt-3">
                <CustomTable
                  data={this.state.manualAllocateList}
                  columns={this.manualAllocationQtyColumns()}
                />
              </div>

            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowOnHandQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"OnHandQty"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateOnHandQtyPdf(e)}
              >
                PDF
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateOnHandQtyExcel(e)}
              >
                Excel
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.onHandQtySummaryOnClick(e)}
              >
                Summary
              </Button>
            </div>
          }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  <FormLabel>Company Code</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={inventoryDataBean.companyCode}
                    name={"companyCode"}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>UOM</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={inventoryDataBean.uomCode}
                    name={"uomCode"}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>OnHandQty</FormLabel>
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={inventoryDataBean.totalOnHandQuantity}
                    className="qty_input text-right"
                    decimalScale={2}
                    name={"totalOnHandQuantity"}
                    disabled={true}
                  />
                </Col>
              </Row>
              <div className="mt-3">
                <CustomTable
                  data={onHandQtyDataList}
                  columns={this.onHandQtyColumns()}
                />
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowOnHandQtySummaryPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel2"}
          closeAlertModalCallBack={this.closeAlertSummaryModalCallBack}
          title={"OnHandQuantity Summary Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateOnHandQtySummaryPdf(e)}
              >
                PDF
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateOnHandQtySummaryExcel(e)}
              >
                Excel
              </Button>
            </div>
          }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={inventoryDataBean.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
              </Row>

              <div className="mt-3">
                <CustomTable
                  data={this.state.onHandQtySummaryDataList}
                  columns={this.onHandQtySummaryColumns()}
                />
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowCustomerQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"CustomerOnOrderDetails"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateCustomerOnOrderPdf(e)}
              >
                PDF
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateCustomerOnOrderExcel(e)}
              >
                Excel
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.summaryOnClick(e)}
              >
                Summary
              </Button>
            </div>
          }
          content={
            <div>
              <CustomerOnOrderDetailsForm
                {...this.state}
                fabricAtsInfoBean={this.state.fabricAtsInfoBean}
                customerQtyDataList={this.state.customerQtyDataList}
              />
            </div>
          }
        />
        {/* ------CUSTOMER ONORDER  SUMMARY POPUP ------*/}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowCustomerSummaryPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel2"}
          closeAlertModalCallBack={this.closeAlertSummaryModalCallBack}
          title={"CustomerOnOrder Summary Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateCustomerSummaryPdf(e)}
              >
                PDF
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateCustomerSummaryExcel(e)}
              >
                Excel
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={fabricAtsInfoBean.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={fabricAtsInfoBean.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={fabricAtsInfoBean.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
              </Row>
              <div className="mt-3">
                <CustomTable
                  data={customerSummaryDataList}
                  columns={this.customerOnHandQtySummaryColumns()}
                />
              </div>
            </div>
          }
        />
        {/* ------VENDOR ONORDER  POPUP ------*/}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowVendorQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"VendorOnOrderDetails"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateVendorOnOrderPdf(e)}
              >
                PDF
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateVendorOnOrderExcel(e)}
              >
                Excel
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.vendorSummaryOnClick(e)}
              >
                Summary
              </Button>
            </div>
          }
          content={
            <div>
              <VendorOnOrderDetailsForm
                {...this.state}
                fabricVendorAtsInfoBean={this.state.fabricVendorAtsInfoBean}
                vendorQtyDataList={this.state.vendorQtyDataList}
                sourceSalesOrderDataList={this.state.sourceSalesOrderDataList}
              />
            </div>
          }
        />
        {/* ------VENDOR ONORDER  SUMMARY POPUP ------*/}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowVendorSummaryPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          closeAlertModalCallBack={this.closeAlertSummaryModalCallBack}
          title={"VendorOnOrder Summary Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateVendorSummaryPdf(e)}
              >
                PDF
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateVendorSummaryExcel(e)}
              >
                Excel
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={fabricVendorAtsInfoBean.fabricStyleCode}
                    disabled={true}
                  />
                </Col>

                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={fabricVendorAtsInfoBean.fabricStyleName}
                    disabled={true}
                  />
                </Col>

                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={fabricVendorAtsInfoBean.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
              </Row>

              <div className="mt-3">
                <CustomTable
                  data={vendorSummaryDataList}
                  columns={this.vendorOnhandQtySummaryColumns()}
                />
              </div>
            </div>
          }
        />
        {/* ------VENDOR INTRANSIT  POPUP ------*/}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowVendorInTransitQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"VendorInTransitDetails"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateVendorInTransitPdf(e)}
              >
                PDF
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateVendorInTransitExcel(e)}
              >
                Excel
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.vendorInTransitSummaryOnClick(e)}
              >
                Summary
              </Button>
            </div>
          }
          content={
            <div>
              <VendorInTransitDetailsForm
                {...this.state}
                vendorInTransitBean={this.state.vendorInTransitBean}
                vendorInTransitQtyDataList={
                  this.state.vendorInTransitQtyDataList
                }
              />
            </div>
          }
        />
        {/* ------VENDOR INTRANSIT  SUMMARY POPUP ------*/}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowVendorInTransitSummaryPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel2"}
          closeAlertModalCallBack={this.closeAlertSummaryModalCallBack}
          title={"Vendor InTransit Summary Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateVendorInTransitSummaryPdf(e)}
              >
                PDF
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateVendorInTransitSummaryExcel(e)}
              >
                Excel
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={vendorInTransitBean.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={vendorInTransitBean.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={vendorInTransitBean.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
              </Row>

              <div className="mt-3">
                <CustomTable
                  data={this.state.vendorInTransitSummaryDataList}
                  columns={this.vendorIntransitOnhandQtySummaryColumns()}
                />
              </div>
            </div>
          }
        />
        {/* ------LAST SALES DETAIL POPUP ------*/}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowAllLastMonthQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Last Sales Detail"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              {this.state.isShowMonthToDateQtyData && (
                <div>
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.generateMonthToDateQtyPdf(e)}
                  >
                    PDF
                  </Button>
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.generateMonthToDateQtyExcel(e)}
                  >
                    Excel
                  </Button>
                </div>
              )}
              {this.state.isShowlast3MonthQtyData && (
                <div>
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.generateLast3MonthPdf(e)}
                  >
                    PDF
                  </Button>
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.generateLast3MonthExcel(e)}
                  >
                    Excel
                  </Button>
                </div>
              )}
              {this.state.isShowlast6MonthQtyData && (
                <div>
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.generateLast6MonthPdf(e)}
                  >
                    PDF
                  </Button>
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.generateLast6MonthExcel(e)}
                  >
                    Excel
                  </Button>
                </div>
              )}
              {this.state.isShowlast12MonthQtyData && (
                <div>
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.generateLast12MonthPdf(e)}
                  >
                    PDF
                  </Button>
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.generateLast12MonthExcel(e)}
                  >
                    Excel
                  </Button>
                </div>
              )}
              {this.state.isShowlast18MonthQtyData && (
                <div>
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.generateLast18MonthPdf(e)}
                  >
                    PDF
                  </Button>
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.generateLast18MonthExcel(e)}
                  >
                    Excel
                  </Button>
                </div>
              )}
              {this.state.isShowlast24MonthQtyData && (
                <div>
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.generateLast24MonthPdf(e)}
                  >
                    PDF
                  </Button>
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.generateLast24MonthExcel(e)}
                  >
                    Excel
                  </Button>
                </div>
              )}
              {this.state.isShowlast36MonthQtyData && (
                <div>
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.generateLast36MonthPdf(e)}
                  >
                    PDF
                  </Button>
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.generateLast36MonthExcel(e)}
                  >
                    Excel
                  </Button>
                </div>
              )}
            </div>
          }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={lastSalesCriteria.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={lastSalesCriteria.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={lastSalesCriteria.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>OrderQuantity</FormLabel>
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={lastSalesCriteria.onOrderQuantity}
                    className="qty_input text-right"
                    decimalScale={2}
                    disabled={true}
                  />
                </Col>
              </Row>

              {this.state.isShowMonthToDateQtyData && (

                <div className="mt-3">
                  <CustomTable
                    data={this.state.monthToDateQtyDataList}
                    columns={this.mtdQtyColumns()}
                  />
                </div>

              )}
              {this.state.isShowlast3MonthQtyData && (

                <div className="mt-3">
                  <CustomTable
                    data={this.state.last3MonthQtyDataList}
                    columns={this.mtdQtyColumns()}
                  />
                </div>

              )}
              {this.state.isShowlast6MonthQtyData && (

                <div className="mt-3">
                  <CustomTable
                    data={this.state.last6MonthQtyDataList}
                    columns={this.mtdQtyColumns()}
                  />
                </div>

              )}
              {this.state.isShowlast12MonthQtyData && (

                <div className="mt-3">
                  <CustomTable
                    data={this.state.last12MonthQtyDataList}
                    columns={this.mtdQtyColumns()}
                  />
                </div>

              )}
              {this.state.isShowlast18MonthQtyData && (

                <div className="mt-3">
                  <CustomTable
                    data={this.state.last18MonthQtyDataList}
                    columns={this.mtdQtyColumns()}
                  />
                </div>

              )}
              {this.state.isShowlast24MonthQtyData && (

                <div className="mt-3">
                  <CustomTable
                    data={this.state.last24MonthQtyDataList}
                    columns={this.mtdQtyColumns()}
                  />
                </div>

              )}
              {this.state.isShowlast36MonthQtyData && (

                <div className="mt-3">
                  <CustomTable
                    data={this.state.last36MonthQtyDataList}
                    columns={this.mtdQtyColumns()}
                  />
                </div>

              )}
            </div>
          }
        />
      </div>
    );
  }
}
class CustomerOnOrderDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      isShowCustomerModule: false,
      isShowSalesModule: false,
      moduleForPopup: [],
      customerQtyDataList: this.props.customerQtyDataList,
    };
  }
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewSalesModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowSalesModule: isOpen,
      moduleForPopup: [],
    });
  };

  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowCustomerOnOrderQtyPopup: isShowPopup,
    });
  };
  customerOnHandQtyColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Customer#",
          "customerCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "CustomerName",
          "customerName",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OpenOrderQty", "onOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerPO#", "customerPONumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesOrder#", "salesOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewSalesModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("S.O Date", "salesOrderDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SO StartDate", "salesOrderStartDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("RevisedShipDate", "revisedLatestShipDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPerson", "salesPersonCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Type", "orderTypeCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ShipToName", "shipToName", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Remarks", "remarks", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    return columns;
  };

  render() {
    let fabricAtsInfoData = this.props.fabricAtsInfoBean;
    let customerQtyDataList = this.props.customerQtyDataList;
    return (
      <div>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <Row>
          <Col sm="1">
            {this.props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleCode"
              type="text"
              value={fabricAtsInfoData.fabricStyleCode}
              disabled={true}
            />
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleName"
              type="text"
              value={fabricAtsInfoData.fabricStyleName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>ColorCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleColorCode"
              type="text"
              value={fabricAtsInfoData.fabricStyleColorCode}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>OnHandQty</FormLabel>
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              value={fabricAtsInfoData.totalCustOnOrderQuantity}
              className="qty_input text-right"
              decimalScale={2}
              name={"totalCustOnOrderQuantity"}
              disabled={true}
            />
          </Col>
        </Row>

        <div className="mt-3">
          <CustomTable
            data={customerQtyDataList}
            columns={this.customerOnHandQtyColumns()}
          />
        </div>
      </div>
    );
  }
}
class VendorOnOrderDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      isShowCustomerModule: false,
      isShowSalesModule: false,
      isShowVendorModule: false,
      isShowPurchaseOrderModule: false,
      modulePopup: [],
    };
  }
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewSalesModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewVendorModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowVendorModule: true,
          moduleForPopup: (
            <PopupVendorModule
              vendorCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPoModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseOrderModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowSalesModule: isOpen,
      isShowVendorModule: isOpen,
      isShowPurchaseOrderModule: isOpen,
      moduleForPopup: [],
    });
  };
  vendorOnOrderQtyColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          " Vendor#",
          "vendorCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewVendorModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "VendorName",
          "vendorName",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderStopDate", "purchaseOrderStopDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Open OrderQty", "onOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderDate", "purchaseOrderStartDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Cust#",
          "reserveCustomerCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Name",
          "reserveCustomerName",
          true
        )

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Type", "orderType", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("DueDate", "purchaseOrderDueDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  render() {
    let fabricVendorAtsInfoData = this.props.fabricVendorAtsInfoBean;
    let vendorQtyDataList = this.props.vendorQtyDataList;
    return (
      <div>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <Row>
          <Col sm="1">
            {this.props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleCode"
              type="text"
              value={fabricVendorAtsInfoData.fabricStyleCode}
              disabled={true}
            />
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleName"
              type="text"
              value={fabricVendorAtsInfoData.fabricStyleName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>ColorCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleColorCode"
              type="text"
              value={fabricVendorAtsInfoData.fabricStyleColorCode}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>InTransit</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="inTransitQuantity"
              type="text"
              value={fabricVendorAtsInfoData.inTransitQuantity}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>VendorQty</FormLabel>
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              value={fabricVendorAtsInfoData.vendorOnOrderQuantity}
              className="qty_input text-right"
              decimalScale={2}
              name={"vendorOnOrderQuantity"}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
        </Row>
        <div className="mt-3">
          <CustomTable
            data={vendorQtyDataList}
            columns={this.vendorOnOrderQtyColumns()}
            label={"Order Details"}
          />
        </div>
      </div>
    );
  }
}
class VendorInTransitDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);

    this.state = {
      isShowVendorModule: false,
      isShowPurchaseOrderModule: false,
      isShowPurchaseInTransitModule: false,
      moduleForPopup: [],
    };
  }
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewVendorModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowVendorModule: true,
          moduleForPopup: (
            <PopupVendorModule
              vendorCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPoModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseOrderModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPurchaseInTransitModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseInTransitModule: true,
          moduleForPopup: (
            <PopupPurchaseInTransitModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowPurchaseOrderModule: isOpen,
      isShowVendorModule: isOpen,
      isShowPurchaseInTransitModule: isOpen,
      moduleForPopup: [],
    });
  };
  vendorIntransitQtyColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Vendor#",
          "vendorCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewVendorModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VendorName", "vendorName", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(" InTransit#", "inTransitNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPurchaseInTransitModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InTransitQty", "inTransitQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TransitDate", "inTransitDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Cust#",
          "customerCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Name",
          "customerName",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Loc", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ETA Date", "etaDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Container#", "containerNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("MillCode", "millCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    return columns;

  };
  render() {
    let vendorInTransitBean = this.props.vendorInTransitBean;
    let vendorInTransitQtyDataList = this.props.vendorInTransitQtyDataList;
    return (
      <div>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseInTransitModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <Row>
          <Col sm="1">
            {this.props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleCode"
              type="text"
              value={vendorInTransitBean.fabricStyleCode}
              disabled={true}
            />
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleName"
              type="text"
              value={vendorInTransitBean.fabricStyleName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>ColorCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleColorCode"
              type="text"
              value={vendorInTransitBean.fabricStyleColorCode}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>InTransit</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="inTransitQuantity"
              type="text"
              value={vendorInTransitBean.inTransitQuantity}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>OnOrderQty</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="vendorOnOrderQuantity"
              type="text"
              value={vendorInTransitBean.vendorOnOrderQuantity}
              disabled={true}
            />
          </Col>
        </Row>

        <div className="mt-3">
          <CustomTable
            data={vendorInTransitQtyDataList}
            columns={this.vendorIntransitQtyColumns()}
          />
        </div>
      </div>
    );
  }
}
class CriteriaView extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.multiFabricCodeRef = React.createRef();
    this.customerRef = React.createRef();
    this.state = {
      criteria: this.props.criteria,
      locations: [],
      businessDivisions: this.props.businessDivisions,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    this.initLookupHandlers();
    this.setFocus();
  }
  setFocus() {
    if (this.customerRef.current != null) {
      this.customerRef.current.focus();
    }
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.props.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  loadPage = () => {
    this.props.loadPage(1);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  addFabric = (e) => {
    if (e.detail === 1) {
      this.props.addFabric();
      if (this.multiFabricCodeRef.current != null) {
        this.multiFabricCodeRef.current.clear();
        this.multiFabricCodeRef.current.focus();
      }
    }
  };
  deleteFabric = (e, val, line) => {
    this.props.deleteFabric(line);
  };
  multifabricCodeOnChange = (e) => {
    this.props.multifabricCodeOnChange(e);
  };
  multiFabricEnterKeyEventHandler = (e) => {
    this.props.multiFabricEnterKeyEventHandler(e);
  };
  displayAutoCompleteMultiFabricList = () => {
    this.props.displayAutoCompleteMultiFabricList();
  };
  fabricColumnDefinitions = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(this.props.is3PL ? "Item#" : "FabricStyle", "code", true)
        .setStyleDetails("left")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "description", true)
        .setStyleDetails("left")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("", <DeleteIcon />, false)
        .setClickDetails(false, true, this.deleteFabric, <DeleteIcon />)
    );

    return columns;
  };

  showHideSecondHeader = (e) => {
    if (e.detail === 1) this.props.showHideSecondHeader();
  };
  render() {
    let criteria = this.props.criteria;
    let fabricDatas = this.props.fabricDatas;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            {" "}
            {this.props.is3PL ? (
              <FormLabel>MultiItem</FormLabel>
            ) : (
              <FormLabel>MultiFabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={this.multiFabricCodeRef}
              name="fabricStylesCode"
              onChange={this.multifabricCodeOnChange}
              value={criteria.fabricStylesCode}
              lookupRequired={true}
              lookupHandler={this.state.fabricLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.multiFabricEnterKeyEventHandler}
              autoCompleteListData={
                this.props.multiFabricPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteMultiFabricList}
              showAutoCompleteList={this.props.showAutoCompleteMultiFabricList}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="1">
            <Button
              className="header_buttons enterFocus"
              id="fabric_Add_Button" //Added Line
              size="sm"
              onClick={(e) => this.addFabric(e)}
              disabled={isDisableFields}
            >
              Add
            </Button>
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Customer</FormLabel>
          </Col>
          {this.props.is3PL ? (
            <Col sm="2">
              <InputTextbox
                ref={this.customerRef}
                name="logisticCustomerCode"
                onChange={this.props.onCustomer_CodeChange}
                value={criteria.logisticCustomerCode}
                lookupRequired={true}
                lookupHandler={this.state.customerLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={
                  this.props.customer_CodeEnterKeyEventHandler
                }
                autoCompleteListData={
                  this.props.customerPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.props.displayAutoCompleteList}
                showAutoCompleteList={this.props.showAutoCompleteCustomerList}
                disabled={isDisableFields}
                isMandatory={true}
              />
            </Col>
          ) : (
            <Col sm="2">
              <InputTextbox
                ref={this.customerRef}
                name="customerCode"
                onChange={this.props.customerCodeOnChange}
                value={criteria.customerCode}
                lookupRequired={true}
                lookupHandler={this.state.customerLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={
                  this.props.customerCodeEnterKeyEventHandler
                }
                autoCompleteListData={
                  this.props.customerPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.props.displayAutoCompleteList}
                showAutoCompleteList={this.props.showAutoCompleteCustomerList}
                disabled={isDisableFields}
                isMandatory={true}
              />
            </Col>
          )}

          <Col sm="3">
            <InputTextbox
              name="customerName"
              onChange={this.onChange}
              value={criteria.customerName}
              disabled={true}
            />
          </Col>
          <Col>
            <CollapseComponent
              isOpen={this.props.isCollapsible_open}
              onClick={(e) => this.showHideSecondHeader(e)}
            />
          </Col>
        </Row>
        {this.props.isCollapsible_open && (
          <div>
            <Row>
              <Col sm="4">
                <CustomTable
                  data={fabricDatas}
                  columns={this.fabricColumnDefinitions()}
                  label={"Fabric Data List"}
                />
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}

function AllFabricCustomerAtsInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <AllFabricCustomerAts {...props} name="" /> <br />
    </div>
  );
}

export default AllFabricCustomerAtsInquiry;
